import * as React from 'react';
import { ReactChild } from 'react';

export interface IProps {
  delay: number;
  children: ReactChild;
}
export interface IState {
  visible: boolean;
}
export default class Expire extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps> = {
    delay: 6000
  };

  private timer: any;

  constructor() {
    super();
    this.setTimer = this.setTimer.bind(this);
    this.clearTimer = this.clearTimer.bind(this);

    this.state = {
      visible: true
    };
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.children !== this.props.children) {
      this.setTimer();
    }
  }

  public componentDidMount() {
    this.setTimer();
  }

  public componentWillUnmount() {
    this.clearTimer();
  }

  public render() {
    return this.state.visible ? <div>{this.props.children}</div> : <span />;
  }

  private setTimer() {
    this.clearTimer();
    this.setState({ visible: true });
    this.timer = setTimeout(() => {
      this.setState({ visible: false });
      this.timer = null;
    }, this.props.delay);
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout-components/Expire.tsx